import React, { useState, useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import Users_no_row from './users_row';
import Pagination from '../../ui/pagination';
import { userService } from "../../../_services";
import Edit_user_pop from './Edit_User_pop';
import Refferral_pop from './ReferralLinksDialog.jsx';
import ChangePass from './ChangePasswordDialog.jsx';
import DeactivateRefferalLinks from './DeactivateReferralLinksDialog.jsx';
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import { Input } from "../../ui/input";
import { Table, TableBody, TableHead, TableHeader, TableRow } from "../../ui/table";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../ui/dialog";
import { Search, Loader2 } from "lucide-react";
        
/**
 * Referral Links Management Page
 * Modernized with shadcn components - Manage referral link users
 */
function Refferallink_Page() {
    const searchInputRef = useRef(null);

    // State
    const [userData, setUserData] = useState([]);
    const [allUserData, setAllUserData] = useState([]);
    const [pageOfItems, setPageOfItems] = useState([]);
    const [searchInput, setSearchInput] = useState("");
    const [loading, setLoading] = useState(true);

    // Modal states
    const [showEditPopup, setShowEditPopup] = useState(false);
    const [showReferralPopup, setShowReferralPopup] = useState(false);
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [showDeactivateLinks, setShowDeactivateLinks] = useState(false);

    // Selected user data
    const [selectedRepId, setSelectedRepId] = useState('');
    const [selectedUserFullname, setSelectedUserFullname] = useState('');
    const [selectedUsername, setSelectedUsername] = useState('');
    const [selectedUserId, setSelectedUserId] = useState('');

    useEffect(() => {
        const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        const [userId, userName] = Usermeta_Data.split(':');
        getReferralLinkUsers(userId, userName, '-1');
    }, []);

    const getReferralLinkUsers = async (userId, userName, repId) => {
        setLoading(true);
        try {
            const userRole = window.atob(localStorage.getItem('UserRole'));
            const apidata = await userService.ReferLinkUser(userId, userName, userRole);
            if (apidata && apidata.length > 0) {
                setUserData(apidata);
                setAllUserData(apidata);
            }
        } catch (error) {
            console.error('Error fetching referral link users:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (value) => {
        const searchText = (value || searchInput).toLowerCase();
        
        if (!searchText) {
            setUserData(allUserData);
            return;
        }

        const filtered = allUserData.filter((user) => {
            const userName = user.userName?.toLowerCase() || '';
            const fullName = `${user.firstName || ''} ${user.lastName || ''}`.toLowerCase();
            const email = user.email?.toLowerCase() || '';
            const groupNumber = user.groupNumber?.toLowerCase() || '';

            return (
                userName.includes(searchText) ||
                fullName.includes(searchText) ||
                email.includes(searchText) ||
                groupNumber.includes(searchText)
            );
        });

        setUserData(filtered.length > 0 ? filtered : [{}]);
    };

    const handleEditUser = (event) => {
        event.stopPropagation();
        const userFullname = event.currentTarget.getAttribute('user_fullname');
        const repid = event.currentTarget.getAttribute('repid');
        setSelectedUserFullname(userFullname);
        setSelectedRepId(repid);
        setShowEditPopup(true);
    };

    const closeEditUser = () => {
        setShowEditPopup(false);
        refreshUserList();
    };

    const handleReferrals = (event) => {
        event.stopPropagation();
        const userFullname = event.currentTarget.getAttribute('user_fullname');
        const numbering = event.currentTarget.getAttribute('numbering');
        setSelectedUserFullname(userFullname);
        setSelectedRepId(numbering);
        setShowReferralPopup(true);
    };

    const handleChangePassword = (event) => {
        event.stopPropagation();
        const indexing = event.currentTarget.getAttribute('indexing');
        setSelectedRepId(indexing);
        setShowChangePassword(true);
    };

    const closeChangePassword = () => {
        setShowChangePassword(false);
        refreshUserList();
    };

    const handleDeactivateLinks = (event) => {
        event.stopPropagation();
        const status = event.currentTarget.getAttribute('status');
        const username = event.currentTarget.getAttribute('username_');
        const userid = event.currentTarget.getAttribute('numbering');
        const nameeeee = event.currentTarget.getAttribute('nameeeee');
        const uid = event.currentTarget.getAttribute('ofcu');

        if (status === "Approvedbyadmin") {
            setSelectedUsername(nameeeee);
            setSelectedUserId(uid);
            setShowDeactivateLinks(!showDeactivateLinks);
        } else {
            // Approve or reject referral link request
            handleApproveReferralRequest(userid, username, status);
        }
    };

    const handleActivateDeactivate = async (event) => {
        const status = event.currentTarget.getAttribute('status');
        const repid = event.currentTarget.getAttribute('numbering');
        const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        const [userId, userName] = Usermeta_Data.split(':');

        try {
            await userService.UpdateUserStatus(userId, userName, repid, status);
            refreshUserList();
        } catch (error) {
            console.error('Error updating user status:', error);
        }
    };

    const handleApproveReferralRequest = async (userId, userName, status) => {
        try {
            // Use correct API: SP_Update_ReferralRequest
            const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            const [adminUserId, adminUserName] = Usermeta_Data.split(':');
            await userService.SP_Update_ReferralRequest(adminUserId, adminUserName, userId, status);
            refreshUserList();
        } catch (error) {
            console.error('Error updating referral request:', error);
        }
    };

    const refreshUserList = () => {
        const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        const [userId, userName] = Usermeta_Data.split(':');
        getReferralLinkUsers(userId, userName, '-1');
    };

    const onChangePage = (pageOfItems) => {
        setPageOfItems(pageOfItems);
    };

    // Auth check
    if (userService.Check_Null_Empty(localStorage.getItem("ajs_user_id"))) {
        return <Navigate replace to="/signup" />;
    }

    if (window.atob(localStorage.getItem('UserRole')) !== "Admin") {
        return <Navigate replace to="/page-not-found" />;
    }

    localStorage.setItem('pagename', 'referralpage');

    const dataToDisplay = searchInput.length ? userData : pageOfItems;

    return (
        <div className="w-full space-y-6">
            {/* Heading */}
            <h1 className="text-2xl font-semibold text-brand-dark">Referral Links</h1>

            {/* Search */}
            <div className="flex items-center justify-between gap-4">
                <div className="relative w-full md:w-96">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-brand-dark/50" />
                    <Input
                        ref={searchInputRef}
                        type="text"
                        placeholder="Search users..."
                        value={searchInput}
                        onChange={(e) => {
                            setSearchInput(e.target.value);
                            handleSearch(e.target.value);
                        }}
                        disabled={loading}
                        className="pl-10"
                    />
                </div>
            </div>

            {/* Table */}
            <Card>
                <CardContent className="p-0">
                    {loading ? (
                        <div className="flex items-center justify-center py-12">
                            <Loader2 className="h-8 w-8 animate-spin text-brand-accent" />
                        </div>
                    ) : (
                        <>
                            <div className="border rounded-md overflow-hidden">
                                <Table>
                                    <TableHeader className="bg-brand-light-1">
                                        <TableRow>
                                            <TableHead className="text-brand-dark">Full Name</TableHead>
                                            <TableHead className="text-brand-dark">Group Number</TableHead>
                                            <TableHead className="text-brand-dark">Email</TableHead>
                                            <TableHead className="text-brand-dark">Referral Status</TableHead>
                                            <TableHead className="text-brand-dark text-right">Actions</TableHead>
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody>
                                        {dataToDisplay.map((userRow, index) => (
                                            <Users_no_row
                                                key={userRow.userId || index}
                                                index={index}
                                                {...userRow}
                                                toggle_add_edit_popup={handleEditUser}
                                                toggle_refferal_pop={handleReferrals}
                                                ClosePopUp={handleChangePassword}
                                                activate_deactivate={handleActivateDeactivate}
                                                deactivate_refferals_links={handleDeactivateLinks}
                                            />
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>

                            {/* Pagination */}
                            <div className="p-4 border-t">
                                <Pagination 
                                    items={userData} 
                                    onChangePage={onChangePage} 
                                    showInfo={true}
                                />
                            </div>
                        </>
                    )}
                </CardContent>
            </Card>

            {/* Modals */}
            <Dialog open={showEditPopup} onOpenChange={(open) => !open && closeEditUser()}>
                <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
                    <DialogHeader>
                        <DialogTitle>Edit {selectedUserFullname}</DialogTitle>
                    </DialogHeader>
                    <Edit_user_pop 
                        repid={selectedRepId} 
                        toggle_add_edit_popup={closeEditUser} 
                    />
                </DialogContent>
            </Dialog>

            {showReferralPopup && (
                <div className="asign_edit_pop edit_user_popup">
                    <Refferral_pop 
                        refferal_title={`${selectedUserFullname} Referrals`} 
                        toggle_refferal_pop={() => setShowReferralPopup(false)} 
                        repid={selectedRepId} 
                    />
                </div>
            )}

            {showChangePassword && (
                <div className="reset_pass_box changepassword_box">
                    <ChangePass 
                        ClosePopUp={closeChangePassword} 
                        repid={selectedRepId} 
                    />
                </div>
            )}

            {showDeactivateLinks && (
                <div className="asign_edit_pop edit_user_popup">
                    <DeactivateRefferalLinks 
                        uname={selectedUsername} 
                        uid={selectedUserId} 
                        deactivate_refferals_links={handleDeactivateLinks} 
                    />
                </div>
            )}
        </div>
    );
}

export default Refferallink_Page;
